import { useEffect } from 'react';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';

import { useBusinessCityQuery } from '@/graphql/generated';
import { useLoginStates } from '@/hooks';

import { DEFAULT_RADIUS } from '../constants';

const globalSearchParamsShape = {
  paging_context: StringParam,
  sc_o: StringParam,
  location: StringParam,
  radius: NumberParam,
};

const GLOBAL_SEARCH_VALUE = 'global_search';
const INCREMENTAL_SEARCH_VALUE = 'navigation_search_incremental_result_click';

export const useGlobalSearch = () => {
  const { isLoggedOut } = useLoginStates();
  const [{ paging_context: pagingContextParam, sc_o: originParam }, setQueryParams] =
    useQueryParams(globalSearchParamsShape);
  const isGlobalSearch = !isLoggedOut && pagingContextParam === GLOBAL_SEARCH_VALUE;
  const isIncrementalSearch = !isLoggedOut && originParam === INCREMENTAL_SEARCH_VALUE;
  const isTopBarSearch = isGlobalSearch || isIncrementalSearch;

  const { data, loading } = useBusinessCityQuery({ skip: !isTopBarSearch });

  useEffect(() => {
    if (isTopBarSearch && !loading && data?.viewer?.xingId?.location?.city) {
      setQueryParams({ location: data.viewer.xingId.location.city, radius: DEFAULT_RADIUS });
    }
  }, [data?.viewer?.xingId?.location?.city, isTopBarSearch, loading, setQueryParams]);

  return {
    isGlobalSearch,
    isUserCityLoading: loading,
  };
};
